module.exports = __webpack_public_path__ + "img/logo_green_alliance_member.8eb02d16.png";